module.exports = __webpack_public_path__ + "static/media/desktop-step4.eaeca28d.png";